import { t } from "@/i18n"

const units = {
  day: "360_DAY_ABBR",
  hour: "360_HOUR_ABBR",
  minute: "360_MINUTE_ABBR",
  second: "360_SECOND_ABBR",
}

const turnSecondsToMinutes = s => {
  const minutes = s / 60
  const seconds = Math.floor(s % 60)
  return [Math.floor(minutes), seconds]
}

const turnSecondsToHours = s => {
  const hours = s / (60 * 60)
  const [minutes] = turnSecondsToMinutes(Math.floor(s % (60 * 60)))
  return [Math.floor(hours), minutes]
}

const turnSecondsToDays = s => {
  const days = s / (60 * 60 * 24)
  const [hours] = turnSecondsToHours(Math.floor(s % (60 * 60 * 24)))
  return [Math.floor(days), hours]
}

export const formatTime = seconds => {
  const sec = parseInt(seconds, 10)
  const isNegative = sec < 0
  const s = Math.abs(sec)
  const sign = isNegative ? `-` : ""

  if (s > 86399) {
    const days = turnSecondsToDays(s)[0]
    const hours = turnSecondsToDays(s)[1]
    const hoursText = hours ? ` ${hours + " " + t(units.hour)}` : ""

    return `${sign}${days} ${t(units.day)}${hoursText}`
  }
  if (s > 3599) {
    const hours = turnSecondsToHours(s)[0]
    const minutes = turnSecondsToHours(s)[1]
    const minutesText = minutes ? ` ${minutes + " " + t(units.minute)}` : ""

    return `${sign}${hours} ${t(units.hour)}${minutesText}`
  }
  if (s > 59) {
    const minutes = turnSecondsToMinutes(s)[0]
    const seconds = turnSecondsToMinutes(s)[1]
    const secondsText = seconds ? ` ${seconds + " " + t(units.second)}` : ""

    return `${sign}${minutes} ${t(units.minute)}${secondsText}`
  }

  return `${sign}${seconds} ${t(units.second)}`
}

export const formatDays = seconds => {
  const sec = parseInt(seconds, 10)
  const isNegative = sec < 0
  const s = Math.abs(sec)
  const sign = isNegative ? `-` : ""

  let days = turnSecondsToDays(s)[0]
  const hours = turnSecondsToDays(s)[1]

  if (hours) days += 1

  return `${sign}${days} ${t(units.day)}`
}
